import JSModal from './JSModal';

export default JSModal;
